/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import { sendrevisedorderwriteExpress, dictList } from '@/api';
export default {
  name: 'SignIn',
  components: {
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Group: Group,
    XInput: XInput,
    XButton: XButton,
    Datetime: Datetime,
    XSwitch: XSwitch,
    ChinaAddressV4Data: ChinaAddressV4Data,
    XTextarea: XTextarea,
    Checklist: Checklist,
    TransferDom: TransferDom,
    Cell: Cell,
    CellBox: CellBox,
    Popup: Popup
  },
  data: function data() {
    return {
      orderId: this.$route.query.orderId,
      logisticsCompany: [],
      form: {
        logistics_company_id: '',
        logistics_num: '',
        code: ''
      },
      logistics_company_id: [],
      btnLoading: false
    };
  },
  watch: {
    // logistics_company_id(val) {
    //   const { code } = logisticsCompany.find((val) => val.id == val[0])
    //   this.form.logistics_company_id = val[0] || ''
    //   this.form.code = code || ''
    // }
  },
  methods: {
    getCompany: function getCompany(val) {
      var _this$logisticsCompan = this.logisticsCompany.find(function (vals) {
          return vals.id == val[0];
        }),
        code = _this$logisticsCompan.code;
      this.form.logistics_company_id = val[0] || '';
      this.form.code = code || '';
    },
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.form.logistics_company_id) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this.$vux.toast.text(i18n.tc("224")));
              case 2:
                if (_this.form.logistics_num) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this.$vux.toast.text(i18n.tc("225")));
              case 4:
                _this.btnLoading = true;
                _context.next = 7;
                return sendrevisedorderwriteExpress(_objectSpread({
                  id: _this.orderId
                }, _this.form));
              case 7:
                res = _context.sent;
                setTimeout(function () {
                  _this.btnLoading = false;
                }, 300);
                if (res.success) {
                  _this.$vux.toast.text(i18n.tc("223"));
                  _this.$router.go(-1);
                } else {
                  _this.$vux.toast.text(res.message);
                }
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getLogisticsCompany: function getLogisticsCompany() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dictList();
              case 2:
                res = _context2.sent;
                if (res.success) _this2.logisticsCompany = (res.data || []).map(function (val) {
                  return _objectSpread(_objectSpread({}, val), {}, {
                    value: val.id + '',
                    name: val.name
                  });
                });
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.getLogisticsCompany();
  }
};